import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CtDashboardsModule } from '@cloud-twin-v2/ct-dashboards/ct-dashboards.module';
import { RightPanelService } from '@common-modules/shared/navigation/right-panel.service';
import { SidePanelImplService } from './side-panel-impl.service';
import { SidePanelService } from './side-panel.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, CtDashboardsModule],
  providers: [
    RightPanelService, // for now, just use standard RP
    {
      provide: SidePanelService,
      useClass: SidePanelImplService,
    },
  ],
})
export class SidePanelModule {}
